const domainState = {
  data: {
    domainStep: 0,
    isDomainDrawerOpen: false,
    isScriptsDrawerOpen: false,
    currentDomain: {},
    domains: [],
    host: "",
  },
};

export default domainState;
